import { GroupVisitControllerApi } from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  groupVisitId: string;
  /** `true` archives the group, `false` restores it. */
  status: boolean;
};

/**
 * @author Atish Bagate
 */
export const useUpdateGroupVisitArchive = () =>
  useMutationWithLoading(async ({ groupVisitId, status }: Params) =>
    new GroupVisitControllerApi(
      getConfigObject()
    ).updateGroupVisitArchiveStatus(groupVisitId, status, getXtenantId())
  );
